module.exports = __webpack_public_path__ + "static/media/logoF.fb75297d.svg";